//cs.js 捷克语
const cs = {
  //公共
  common: {
    notSupport: 'váš prohlížeč nepodporuje režim celé obrazovky',
    loadFail: 'načítání motivu se nezdařilo',
    noPermission: 'omlouvám se, nemáte oprávnění k přístupu na tuto stránku',
    backHome: 'Zpět na úvodní stránku',
    noExit: 'stránka, kterou se pokoušíte otevřít, neexistuje',
    serverError: 'omlouváme se, na serveru došlo k chybě',
    slide: 'Přejeďte doprava',
    veryHigh: 'Velmi vysoká',
    high: 'Vysoká',
    target: 'Nastavená',
    urgentLow: 'Velmi nízká',
    agpNoData: 'Přehled AGP vyžaduje pro vygenerování dat alespoň 5 dní',
    noDataStr: 'Žádná data',
    setting: 'Nastavení',
    personInfo: 'Základní informace',
    updatePwd: 'Změnit heslo',
    upHead: 'Nahrajte obrázky',
    inRange: 'V dosahu',
    normal: 'Normální',
    low: 'Nízký',
    previous: 'Předchozí',
    next: 'Další',
    search: 'Vyhledávání',
    reset: 'Resetovat',
    cancel: 'Zrušit',
    ok: 'Dobře',
    confirm: 'Potvrdit',
    save: 'Uložit',
    submit: 'Předložit',
    successful: 'Úspěšný',
    pleaseEnter: 'Zadejte prosím',
    pleaseSelect: 'Vyberte prosím',
    success: 'Úspěch',
    confirmLogout: 'Opravdu se chcete odhlásit?',
    updateSuccessed: 'Aktualizace proběhla úspěšně',
    warning: 'Varování',
    date: 'Datum',
    start: 'Start',
    end: 'Konec',
    sevenDays: '7 dní',
    fourteenDays: '14 dní',
    thirtyDays: '30 dní',
    signOut: 'Odhlásit se',
    personalInformation: 'Osobní údaje',
    email: 'E-mail',
    name: 'Jméno',
    mobile: 'Mobil',
    dateOfBirth: 'Datum narození',
    gender: 'Pohlaví',
    diabeteType: 'Typ diabetu',
    dateOfDignose: 'Rok diagnózy',
    remarks: 'Poznámky',
    optionMale: 'Muž',
    optionFemale: 'Žena',
    optionUnknow: 'Raději neuvádět',
    noDiabetes: 'Žádný diabetes',
    diabeteTypeI: 'Typ I',
    diabeteTypeII: 'Typ II',
    diabeteSpecial: 'Speciální',
    diabeteGestational: 'Gestační diabetes',
    diabeteOthers: 'Ostatní',
    ruleMsgEmail: 'Zadejte prosím e-mail',
    ruleMsgName: 'Zadejte prosím jméno',
    ruleMsgMobile: 'Zadejte prosím mobil',
    ruleMsgBirthday: 'Vyberte datum narození',
    ruleMsgSex: 'Vyberte prosím pohlaví',
    ruleMsgDiabeteType: 'Vyberte typ diabetu',
    ruleMsgDateOfDignose: 'Vyberte rok diagnózy',
    ruleMsgRemarks: 'Zadejte poznámky',
    ruleMsgCorrectMobile: 'Zadejte prosím správný mobil',
    oldPassword: 'Staré heslo',
    newPassword: 'Nové heslo',
    confirmPassword: 'Potvrďte heslo',
    ruleMsgOldPassword: 'Zadejte staré heslo',
    ruleMsgNewPassword: 'Zadejte prosím nové heslo',
    ruleMsgConfirmPassword: 'Prosím potvrďte heslo',
    passwordInconsistent: 'Dvě zadání hesla jsou nekonzistentní',
    passwordModifySuccessed:
      'Vaše heslo bylo resetováno, přihlaste se prosím znovu!',
    monday: 'Po',
    tuesday: 'Út',
    wednesday: 'St',
    thursday: 'Čt',
    friday: 'Pá',
    saturday: 'So',
    sunday: 'Ne',
    sn: 'Sériové číslo',
    startDate: 'Start date',
    days: 'dní',
    pdfDate: 'Nastavená',
    close: 'blízko',
    // inputTip: 'Zadejte prosím klíčová slova pro vyhledávání',
    inputTip: 'Zadejte prosím klíčová slo...',
    polarization: 'Inicializace zařízení',
    hour: 'h',
    minutes: 'min',
    seconds: 's',
    reportDownLoadTip: 'Váš přehled nebyl vygenerován po dobu 5 dnů.',
    age: 'Stáří',
    goal: 'Cíl',
    expired: 'senzor Vypršela platnost',
    lastTime: 'Čas poslední aktualizace',
    timeZone: 'časové pásmo'
  },
  //路由
  route: {
    login: 'Přihlášení',
    forget: 'Zapomenout heslo',
    home: 'Domů',
    glucoseReport: 'Glukózová zpráva',
    sessionReport: 'Zpráva o měření',
    eventList: 'Seznam událostí',
    followerList: 'Seznam sledujících',
    followerListQ: 'Požadavek pozorovatele',
    settings: 'Nastavení',
    profile: 'Profil'
  },
  //登录
  login: {
    rememberMe: 'Zapamatovat si',
    forgetPassword: 'Zapomenout heslo',
    agree: 'Přihlášení znamená souhlas s FurCarer',
    privacyPolicy: 'Zásady ochrany osobních údajů',
    CGMUser: 'Uživatel CGM',
    follower: 'Sledující',
    ruleMsgPassword: 'Zadejte prosím e-mail',
    login: 'Přihlášení',
    phonePlacehold: 'Zadejte prosím telefonní číslo',
    codePlacehold: 'Zadejte prosím ověřovací kód',
    codePlaceholdInput: 'Zadejte pro...',
    phoneTip: 'Telefonicky',
    emialTip: 'E-mailem',
    codeTip: 'Získejte ověřovací kód',
    reGetTip: 'Opětovná akvizice'
  },
  layout: {
    collapseUp: 'Skrýt nabídku',
    collapseDown: 'Rozbalte nabídku',
    refresh: 'Obnovit',
    backHome: 'Domov',
    helpCenter: 'Centrum nápovědy',
    fullScreen: 'Celá obrazovka'
  },
  //忘记密码
  forget: {
    ruleMsgCode: 'Zadejte kód',
    sendCode: 'Odeslat kód',
    tipsMsgSendSuccess: 'Ověřovací kód byl úspěšně odeslán!',
    tipsMsgModifySuccess: 'Změna hesla úspěšná'
  },
  //首页
  home: {
    title: 'Portál FurCarer',
    todaysGlucose: 'Glukóza dnes',
    todaysOverview: 'Přehled dnes',
    maxGlucose: 'Max. Glukóza',
    minGlucose: 'Min. Glukóza',
    avgGlucose: 'Prům. Glukóza',
    maxmumVariation: 'Maximální variace',
    glucose: 'Glukóza',
    tir: 'TIR',
    latestGlucose: 'Nejnovější glukóza',
    todayPercentage: '% dneška v jiném rozsahu',
    fourHour: '4 hodiny',
    eightHour: '8 hodin',
    twelveHour: '12 hodin',
    twentyFourHour: '24 hodin',
    glucoseOnly: 'Pouze glukóza',
    sessionOverview: 'Přehled relace',
    glocuseMetrics: 'Metriky glukózy',
    agp: 'AGP',
    dailyGlucose: 'Denní glukóza',
    sessionGlucose: 'Relace glukózy',
    standTir: 'Standardní TIR',
    customTir: 'TIR na míru',
    cancleGz: 'Přestat sledovat',
    cancleText: 'Chcete přestat sledovat aktuálního uživatele?',
    helpCenterTip: 'Funkce ještě není otevřená'
  },
  //血糖报告
  glucoseReport: {
    statics: 'Statický',
    sixHour: '6 hodin',
    avgGlucose: 'Průměrná glukóza',
    maxGlucose: 'Max glukóza',
    minGlucose: 'Min. glukóza',
    cv: 'CV',
    high: 'Vysoká čísla',
    low: 'Nízká čísla',
    normal: 'Normální čísla',
    tir: 'TIR',
    estimatedA1c: 'Odhadovaná A1c',
    min: 'Min',
    avg: 'Průměr',
    max: 'Max',
    maxVariation: 'Maximální variace'
  },
  //血糖档案
  glucoseProfile: {
    avg: 'Průměr',
    sd: 'SD',
    cv: 'CV'
  },
  //事件列表
  eventList: {
    all: 'Vše',
    bg: 'BG',
    meal: 'Jídlo',
    sport: 'Sportovní',
    insulin: 'Inzulín',
    alert: 'Upozornění',
    eventType: 'Typ události',
    description: 'Popis',
    note: 'Poznámka',
    highAlert: 'varovné upozornění',
    calibration: 'Kalibrace',
    meds: 'Léky',
    time: 'Čas',
    detail: 'Detail',
    weigt: 'Hmotnost'
  },
  // 关注列表
  followerList: {
    title: 'Sledování uživatelů',
    tabTitle: 'Správa sledujících',
    refreshText:
      'Automatická aktualizace (seznam uživatelů se automaticky obnovuje každých 30 sekund)',
    addText: 'Přidat',
    dataText: 'Data získána',
    timeText: 'minut',
    hourText: 'hodin',
    agoText: 'před',
    tableEmail: 'Zadejte číslo účtu',
    searchPlacehold: 'Pro vyhledávání zadejte číslo svého účtu',
    pending: 'Čeká na vyřízení',
    approved: 'Schválení',
    rejected: 'Odmítnuto',
    addFollower: 'Přidat sledujícího',
    editFollower: 'Upravit sledujícího',
    tableName: 'Jméno',
    tableAddTime: 'Přidat čas',
    tableStatus: 'Stav',
    tableApproved: 'Schválený',
    tableReject: 'Odmítnout',
    tableStartSharing: 'Začněte sdílet',
    tableStopSharing: 'Přestat sdílet',
    op: 'Spravovat',
    sharing: 'Sdílení',
    notSharing: 'Nesdílet',
    tableRemove: 'odstranit',
    note: 'Poznámka',
    message: 'Zpráva',
    ruleMsgEmailEmpty: 'Pro vyhledávání zadejte e-mail',
    ruleMsgNote: 'Zadejte prosím poznámku',
    ruleMsgMessage: 'Zanechte prosím zprávu',
    ruleMsgEmailCorrect: 'Zadejte prosím správný e-mail',
    formAcknowledge:
      'Beru na vědomí, že přidání sledujícího umožní tomuto uživateli vidět moje data',
    sendFollowRequest: 'Odeslat žádost o sledování',
    setNote: 'Nastavit poznámku',
    tipsAcknowledge:
      'Zaškrtněte prosím políčko, berete na vědomí, že přidání sledujícího umožní tomuto uživateli vidět moje data',
    stopSharing: 'Přestat sdílet',
    startSharing: 'Začít sdílet',
    removeUser: 'Odebrat uživatele',
    confirmStopSharing:
      'Opravdu chcete přestat sdílet glukózu s tímto uživatelem?',
    confirmStartSharing:
      'Opravdu chcete začít sdílet glukózu s tímto uživatelem?',
    confirmRemove: 'Opravdu chcete tohoto uživatele odebrat ze seznamu?',
    approvedFollower: 'Schválený sledující',
    rejectFollower: 'Odmítnout sledujícího',
    confirmApproved: 'Opravdu tuto žádost o sledování schvalujete?',
    confirmReject: 'Opravdu odmítnete tuto žádost o sledování?',
    addTime: 'Přidat čas',
    check: 'Kontrola',
    remove: 'Odstranit',
    removeUserTitle: 'Opravdu chcete tohoto uživatele odebrat ze seznamu?'
  },
  //设置
  settings: {
    title: 'Nastavení hladiny glukózy',
    unitSet: 'Nastavení jednotky',
    targetSet: 'Přizpůsobené nastavení TIR',
    alertSet: 'Nastavení upozornění',
    highAlert: 'Vysoká výstraha',
    lowAlert: 'Nízká výstraha',
    urgentLow: 'Naléhavá nízká',
    urgentHigh: 'Velmi vysoká',
    target: 'Nastavená'
  },
  // pdf
  pdf: {
    dailyStatistics: 'Denní statistiky',
    title: 'Zpráva AGP: Kontinuální monitorování glukózy',
    page: 'Strana',
    generated: 'Vygenerováno',
    lage: 'LAGE',
    mage: 'MAGE',
    modd: 'MODD',
    range: 'Čas v rozsahu',
    timeInRange: 'Čas v rozsahu (TIR)',
    agpTitle: 'Ambulantní glukózový profil (AGP)',
    agpSubTitle:
      'AGP je souhrn hodnot glukózy za sledované období, přičemž medián (50 %) a další percentily jsou zobrazeny, jako by se vyskytly během jediného dne',
    dailyTitle: 'Denní glukózový profil',
    dailySubTitle:
      'Každý denní profil představuje období od půlnoci do půlnoci.',
    device: 'Zařízení',
    tDevice: 'Koncové zařízení',
    print: 'Vytisknout',
    model: 'Model',
    deviceSn: 'SN zařízení ',
    effectiveData: 'Efektivní data',
    days: 'dní',
    appVer: 'Verze aplikace',
    smartPhoneModel: 'Model chytrého telefonu',
    osVersion: 'Verze OS',
    appSetting: 'Nastavení aplikace',
    GoalsforType1andType2Diabetes: 'Cíle pro diabetes typu 1 a typu 2',
    Each1timeinrange15minutes: 'Každý 1% čas v rozsahu =~15 minut',
    note: 'Poznámka: Jednotka % platí pro standard DCCT a jednotka mmol/mol platí pro standard IFCC.',
    DOB: 'DOB',
    SN: 'SN'
  },
  // 字段
  field: {
    timeCgmActive: 'Aktivní čas CGM ',
    gmi: 'GMI',
    gri: 'GRI',
    eHbA1c: 'Průměrná glukóza',
    avgPerDay: 'Průměrné kalibrace za den',
    glucoseAbility: 'Variabilita glukózy',
    lage: 'LAGE',
    mage: 'MAGE',
    tar: 'TAR',
    tbr: 'TBR',
    calibrations: 'Kalibrační čas'
  },
  agp: {
    agpTitle: 'Ambulantní glukózový profil (AGP)',
    centerLine: 'Medián',
    areaLine: 'Interval',
    target: 'Cílový rozsah'
  },
  basic: {
    customTir: 'Vlastní TIR',
    bloodTip: 'Nastavení připomenutí glukózy',
    bloodUnit: 'Jednotka glukózy',
    highTip: 'Upozornění na vysokou hladinu glukózy',
    lowTip: 'Upozornění na nízkou hladinu glukózy',
    unitText: 'Automaticky nastaveno podle země',
    selectTip:
      'Kliknutím na ikonu vyberte nebo zrušte výběr odpovídajícího data',
    selectAll: 'Vyberte vše'
  },
  report: {
    threeMonth: 'Poslední 3 měsíce',
    sixMonth: 'Téměř 6 měsíců',
    yearText: 'Loni',
    showAll: 'Zobrazit vše',
    all: 'Vše',
    selectDate: 'Vyberte časové období',
    to: 'na',
    startDt: 'Datum zahájení',
    endDt: 'Datum ukončení',
    betaTest: 'Beta testování',
    bloodData: 'Údaje o glukóze',
    userCount: 'Uživatelský účet'
  },
  petDetail: {
    variety: 'Plemeno',
    type: 'Typ inzulínu',
    freq: 'Frekvence inzulínu',
    lente: 'Dlouhodobě působící',
    insulin: 'Inzulin glargin',
    pzi: 'Protaminový zinkový inzulín',
    nph: 'Sředně působící inzulín',
    detemir: 'Inzulín detemir'
  },
  pdfReport: {
    title: 'Zpráva AGP: Kontinuální monitorování glukózy',
    snNumber: 'SN',
    page: 'Strana',
    createTime: 'Vygenerováno',
    petInfo: 'Informace o mazlíčcích',
    petName: 'Jméno mazlíčka',
    birthday: 'Datum narození',
    freq: 'Frekvence inzulínu',
    petType: 'Typ domácího mazlíčka',
    age: 'Stáří',
    registerType: 'Typ stříkačky',
    basicBloodData: 'Metriky glukózy',
    dbText: 'Čas v rozsahu (TIR)',
    target: 'Cíle pro diabetes typu 1 a typu 2',
    recordTime: 'Čas nahrávání',
    tag: 'Značka',
    event: 'Událost',
    eventDetail: 'Podrobnosti o události',
    mulityText: 'Vícedenní graf trendu glukózy',
    mulitySubText:
      'Vícedenní glukózové profily představují časový interval jednoho cyklu zařízení',
    avageBlood: 'Průměrná glukóza',
    bloodText: 'MODD',
    highTip: 'Upozornění na vysokou hladinu glukózy',
    lowTip: 'Upozornění na nízkou hladinu glukózy',
    cat: 'Kočka',
    dog: 'Pes',
    country: 'Země',
    insulinDose: 'Dávka inzulínu',
    weightUnit: 'kg'
  },
  // eventDetail for cs.js
  eventDetail: {
    Empty: 'Prázdný',
    After_Breakfast: 'Po snídani',
    Before_Lunch: 'Před obědem',
    Breakfast: 'Snídaně',
    Lunch: 'Oběd',
    Dinner: 'Večeře',
    Before_Sleep: 'Před spánkem',
    Extra: 'Další',
    Short_acting: 'Krátce působící',
    Pre_mixed: 'Premixované',
    Long_acting: 'Dlouhodobé',
    Middle_acting: 'Střednědobé',
     hour: 'h',
    minutes: 'min',
  }
};
export default cs;
